import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const HomeBanner2 = ({ companiesLogo, lang }) => {
  const logos = companiesLogo.companyLogos

  return (
    <div className={`container-orange home-info-text2`}>
      {lang === "en" ? (
        <h4 className="recommended-title">Dalia in the media</h4>
      ) : (
        <h4 className="recommended-title">Dalia en los medios</h4>
      )}
      {lang === "en" ? (
        <h2>They talk about Dalia Empower</h2>
      ) : (
        <h2>Ellos hablan de Dalia Empower</h2>
      )}

      <div className="logo">
        {logos.map((logo, index) => {
          const pathToImage = getImage(logo.localFile)
          return (
            <a key={index} href={logo.caption} target="_blank" rel="noreferrer">
              <GatsbyImage image={pathToImage} alt={logo.alternativeText} />
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default HomeBanner2
